export default __webpack_public_path__ + "static/media/wasp.127d9870.png";